import React, { ReactElement } from "react";
import WhatsappIcon from "@icons/whatsappIcon.svg";
import styles from "./faq.module.scss";

export const FaqCommunications = (props: Props): ReactElement => {
  return (
    <div className={styles.commsWrapper}>
      <div className={styles.commsInside}>
        <div className={styles.avatarGroup}>
          {props.avatarUrls.map((url, i) => (
            <img
              key={i}
              className={i == 1 ? styles.avatarBig : styles.avatarSmall}
              src={url}
              alt=""
            />
          ))}
        </div>
        <div className={styles.headAndSupportText}>
          <p className={styles.heading}>{props.title}</p>
          <p className={styles.supportText}>{props.supportingText}</p>
        </div>
        <div className={styles.actions}>
          <button className={styles.whatsappButton} onClick={props.onCtaClick}>
            <WhatsappIcon /> {props.ctaLabel}
          </button>
        </div>
      </div>
    </div>
  );
};

interface Props {
  avatarUrls: string[];
  title: string;
  supportingText: string;
  ctaLabel: string;
  onCtaClick?: () => void;
}
